module.exports = __webpack_public_path__ + "img/personal.c960f152.png";